var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.$t('components.modals.campaign.importTitle'),"action":"import","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('div',{staticClass:"mt-4"},[_c('input',{attrs:{"type":"file","accept":"application/json"},on:{"change":_vm.onFileChange}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }